const PaymentMethod = Object.freeze({
    AdyenComponent: 'AdyenComponent',
    alipay: 'alipay',
    BANK_TRANSFER: 'BANK_TRANSFER',
    CASH_ON_DELIVERY: 'CASH_ON_DELIVERY',
    COINIFY_PAYMENTS: 'Conify',
    CREDIT_CARD: 'CREDIT_CARD',
    CRYPTO_CREDIT: 'CRYPTO_CREDIT',
    directEbanking: 'directEbanking',
    DW_APPLE_PAY: 'DW_APPLE_PAY',
    GIFT_CERTIFICATE: 'GIFT_CERTIFICATE',
    GooglePay: 'GooglePay',
    ideal: 'ideal',
    klarna: 'klarna',
    klarna_account: 'klarna_account',
    MOCK_FREE: 'MOCK_FREE',
    'Payment Link': 'Payment Link',
    paypal: 'paypal',
    PayPalExpress: 'PayPalExpress',
    POINTSPAY_EYGP: 'PointsPay',
    VOUCHER: 'VOUCHER',
    WeChat: 'WeChat',
    WeChatPay: 'WeChatPay',
    YOOMONEY: 'YooMoney',
    MiraklYOOX: 'Mirakl Yoox',
    MiraklBESTSEC: 'Mirakl Bestsecret',
    MiraklSPO: 'Mirakl SPO',
    MOLIERA2: 'Moliera2',
    TRADEBYTE_BRBC: 'TB Breuninger',
    TRADEBYTE_GALERIA: 'TB Galeria',
    TRADEBYTE_OCDE: 'TB OutletCity',
    TRADEBYTE_INDE: 'TB Intersport',
    TRADEBYTE_ISDI: 'TB Intersport 2',
    TRADEBYTE_MOPL: 'TB Modivo',
    TRADEBYTE_OTDO: 'TB OTTO',
    TRADEBYTE_ANDE: 'TB AboutYou',
    TRADEBYTE_SEUK: 'TB SecretSales',
    TRADEBYTE_FADE: 'TB Fashionette',
    TRADEBYTE_AMDE: 'TB Amazon',
    TRADEBYTE_AMAZON_US: 'TB Amazon US',
    TRADEBYTE_VPFR: 'TB VeePee',
    TRADEBYTE_VPIT: 'TB Privalia',
    TRADEBYTE_DECATHLON: 'TB Decathlon',
    TRADEBYTE_MIINTO: 'TB Miinto',
    TRADEBYTE_WALMART: 'TB Walmart',
    TRADEBYTE_GLOBUS: 'TB Globus',
    TRADEBYTE_STADIUM: 'TB Stadium',
    TRADEBYTE_MANOR: 'TB Manor',
    TRADEBYTE_NORDSTORM: 'TB Nordstorm',
    TRADEBYTE_ZALANDO: 'TB Zalando',
    TRADEBYTE_ARCHIVIST: 'TB Archivist',
});

export {PaymentMethod}